export default function textSlider(idSlide:string):string{
    return `
        <div id="${idSlide}" class="slider-text">
            <div class="slider-container">
            </div>
            <div class="slider-options">
                <span class="slide-legend">
                </span>
                <div class="control-group">
                    <button type="button" class="prev">&lt;</button>
                    <button type="button" class="next">&gt;</button>
                </div>
            </div>
        </div>
    `;
}